import { render, staticRenderFns } from "./AgentParamItem.vue?vue&type=template&id=21f205c1&scoped=true&"
import script from "./AgentParamItem.vue?vue&type=script&lang=js&"
export * from "./AgentParamItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentParamItem.vue?vue&type=style&index=0&id=21f205c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f205c1",
  null
  
)

export default component.exports